const getCharacterDataName = ({ id, name }) => {
  if (name) { return name }

  if (id) {
    const tailId = id.length > 2 ? id.substring(id.length - 2) : id
    return `qharacter-${tailId}`
  }

  return 'qharacter'
}

export default {
  confirmDeleteAnimation: data => `Delete ${data.name}?`,
  confirmDeleteCharacter: data => `Delete ${getCharacterDataName(data)}?`,
  delete: 'Delete',
  empty: 'Empty',
  errorUpdatingTryAgain: 'An error occurred during update. Try again later.',
  errorDeletingTryAgain: 'An error occurred during delete. Try again later.',
  getCharacterDataName,
  lastModified: 'Modified',
  loadCharacter: 'Load character',
  loadingCharacterMessage: name => name ? `Loading ${name}...` : 'Loading character...',
  loadingPoseSequenceMessage: name => name ? `Loading ${name}...` : 'Loading pose/animation...',
  moveToTop: 'Move to top',
  name: 'Name',
  new: 'New',
  noCharacterData: 'An empty world without qharacters looks like this.',
  notes: 'Notes',
  poseSequenceNameIsUsed: 'Name must be different from other poses/animations.',
  share: 'Share',
  updateName: 'Update name'
}
